import produce from 'immer';

import * as Types from './types';
import * as helpers from '../helpers';
import { actionTypes } from './constants';

export const defaultStateRaw: Types.IDeviceState = {
    ua: '',
    alias: '',
    deviceId: '',
    uaOrigin: '',
    osVersion: '',
    os: 'windows',
    name: 'windows',
    browserVersion: '',
    browserLanguage: '',
    deliveryPlatform: '',
    formFactor: 'desktop',
    browserName: 'chrome',
    clientPlatform: 'web',
    orientation: 'portrait',
    isCrawled: false,
    isDesktop: true,
    isMobile: false,
    isTablet: false,
    isOtherOs: false,
    isPortrait: true,
    isInWrapper: false,
    isLandscape: false,
    isTouchDevice: false,
    isOtherBrowser: false
};

export const defaultState = { ...defaultStateRaw, ...helpers.getDevice() } as Types.IDeviceState;

export const reducer = produce((draftState, action: Types.TDeviceAction): Types.IDeviceState | void => {
    switch (action.type) {
        case actionTypes.UPDATE_DEVICE: {

            Object.assign(draftState, {
                ...action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
